import React from 'react'
import '../index.css';
import {render} from 'react-dom';
import helm1 from './helm1.jpg';

function Scroller(props){
    console.log(props.name)
    return(<>
        <div className="scrollEffect" >
                <div className={props.name}>
                    <span>welcome.</span>
                </div>
        </div>
    </>);
}



class Sick extends React.Component{
    constructor(props){
        super(props);
        this.scroller = this.scroller.bind(this);
        this.setFade = this.setFade.bind(this);
        this.setWhite = this.setWhite.bind(this);
        this.state = {
            name: "scroll",
            flag: true,
        }

    }

    setFade = () => {
        this.setState({name: "scroll",flag: true});
    }

    setWhite = () => {
        this.setState({name:"stag",flag:false});
    }

    scroller = (flag) => {
        if(flag){
            return this.setWhite;
        }
        else{
            return this.setFade;
        }

    }



    render(){
        return(
            <>
            <div onClick={this.scroller(this.state.flag)}>
                <Scroller name = {this.state.name}  />
            </div>

            </>
        );
    }
}

export default Sick;